export default () => { 
    const tableFormTabulation = document.querySelector('.js-TableFormTabulation');  
     
    if(tableFormTabulation){ 
        const tabHeader = document.querySelector(".TableForm__TabulationHeader");
        const tabButton = document.querySelectorAll(".js-Tab");
        const contents = document.querySelectorAll(".js-TabContent");

        const tabButtonFirst = tabButton[0];
        const tabContentFirst = contents[0];

        tabButtonFirst.classList.add('active');
        tabContentFirst.classList.add('active');
        
        tabHeader.addEventListener('click', e => {
            tabButtonFirst.classList.remove('active'); 
            tabContentFirst.classList.remove('active'); 

            const id = e.target.dataset.id;
            if (id) {
              tabButton.forEach(btn => {
                btn.classList.remove("active");
              });
              e.target.classList.add("active");
          
              contents.forEach(content => {
                content.classList.remove("active");
              });
              const element = document.getElementById(id);
              element.classList.add("active");
            }
        })
         
    }

}
 